class AddressDetails {
    constructor(data, errorPrefix) {
        this.data = data !== null && data !== void 0 ? data : {};
        this.errorPrefix = errorPrefix ? `${errorPrefix}: ` : '';
    }
    setAddress(value) {
        this.data.address = value;
    }
    validateAddress() {
        var _a, _b;
        if (!(((_b = (_a = this.data.address) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0)) {
            return Error(`${this.errorPrefix}Street address may not be empty`);
        }
    }
    setAddress2(value) {
        this.data.address2 = value;
    }
    validateAddress2() {
        var _a, _b;
        if (!(((_b = (_a = this.data.address2) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0)) {
            return Error(`${this.errorPrefix}Unit may not be empty`);
        }
    }
    setCity(value) {
        this.data.city = value;
    }
    validateCity() {
        var _a, _b;
        if (!(((_b = (_a = this.data.city) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0)) {
            return Error(`${this.errorPrefix}City may not be empty`);
        }
    }
    setCountry(value) {
        this.data.country = value;
    }
    validateCountry() {
        var _a, _b;
        if (!(((_b = (_a = this.data.country) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0)) {
            return Error(`${this.errorPrefix}Country may not be empty`);
        }
    }
    setRegion(value) {
        this.data.region = value;
    }
    validateRegion() {
        var _a, _b;
        if (!(((_b = (_a = this.data.region) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0)) {
            return Error(`${this.errorPrefix}State/Region may not be empty`);
        }
    }
    setPostalCode(value) {
        this.data.postalCode = value;
    }
    validatePostalCode() {
        var _a, _b;
        if (!(((_b = (_a = this.data.postalCode) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0)) {
            return Error(`${this.errorPrefix}Postal code may not be empty`);
        }
    }
    valid() {
        return this.errors().length === 0;
    }
    errors() {
        return [
            this.validateAddress(),
            this.validateCity(),
            this.validateRegion(),
            this.validateCountry(),
            this.validatePostalCode(),
        ].filter((error) => error !== undefined);
    }
}
export default AddressDetails;
